// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CustomerServiceOutlinedSvg from "@ant-design/icons-svg/es/asn/CustomerServiceOutlined";
import AntdIcon from '../components/AntdIcon';

var CustomerServiceOutlined = function CustomerServiceOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: CustomerServiceOutlinedSvg
  }));
};

CustomerServiceOutlined.displayName = 'CustomerServiceOutlined';
export default React.forwardRef(CustomerServiceOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/CustomerServiceOutlined.js
// module id = 899
// module chunks = 0